import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import EnterpriseIcon, { PageFirstIcon, ChevronLeftIcon, ChevronRightIcon, PageLastIcon } from '@enterprise-ui/icons';
import classnames from 'classnames';
import React from 'react';
import alertUserOfDeprecatedProps from '../utils/deprecation.js';
import Button from './Button.js';

var _excluded = ["className", "currentPage", "data-testid", "onRequestNext", "onRequestPrev", "onRequestFirst", "onRequestLast", "totalPages"];
var Pagination = function Pagination(props) {
  var className = props.className,
    currentPage = props.currentPage,
    dataTestId = props['data-testid'],
    onRequestNext = props.onRequestNext,
    onRequestPrev = props.onRequestPrev,
    onRequestFirst = props.onRequestFirst,
    onRequestLast = props.onRequestLast,
    totalPages = props.totalPages,
    otherProps = _objectWithoutProperties(props, _excluded);
  alertUserOfDeprecatedProps('Pagination', otherProps);
  var finalClasses = classnames('C-Pagination', {
    '--pageIndicator': totalPages && currentPage
  }, className);
  return /*#__PURE__*/React.createElement("div", {
    className: finalClasses,
    "data-testid": dataTestId,
    role: "navigation"
  }, onRequestFirst !== undefined && /*#__PURE__*/React.createElement(Button, {
    type: "ghost",
    iconOnly: true,
    onClick: onRequestFirst,
    disabled: !onRequestFirst || currentPage === 1,
    "data-testid": dataTestId ? "".concat(dataTestId, "_first") : null,
    "aria-label": "go to first page"
  }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
    size: "lg",
    icon: PageFirstIcon
  })), /*#__PURE__*/React.createElement(Button, {
    type: "ghost",
    className: "C-Pagination__prev",
    iconOnly: true,
    onClick: onRequestPrev,
    disabled: !onRequestPrev || currentPage === 1,
    "data-testid": dataTestId ? "".concat(dataTestId, "_back") : null,
    "aria-label": "go to previous page"
  }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
    size: "lg",
    icon: ChevronLeftIcon
  })), totalPages && currentPage && /*#__PURE__*/React.createElement("p", {
    "aria-live": "polite",
    className: "C-Pagination__pageIndicator hc-mb-none"
  }, currentPage, " of ", totalPages), /*#__PURE__*/React.createElement(Button, {
    type: "ghost",
    className: "C-Pagination__next",
    iconOnly: true,
    onClick: onRequestNext,
    disabled: !onRequestNext || currentPage === totalPages,
    "data-testid": dataTestId ? "".concat(dataTestId, "_next") : null,
    "aria-label": "go to next page"
  }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
    size: "lg",
    icon: ChevronRightIcon
  })), onRequestLast !== undefined && /*#__PURE__*/React.createElement(Button, {
    type: "ghost",
    iconOnly: true,
    onClick: onRequestLast,
    disabled: !onRequestLast || currentPage === totalPages,
    "data-testid": dataTestId ? "".concat(dataTestId, "_last") : null,
    "aria-label": "go to last page"
  }, /*#__PURE__*/React.createElement(EnterpriseIcon, {
    size: "lg",
    icon: PageLastIcon
  })));
};
Pagination.displayName = 'Pagination';

export { Pagination as default };
